import request from '@/utils/request'

const url = 'admin/user_approval_setting'

export function getApprovalSetting() {
  return request({
    url: `${url}/get`,
    method: 'post'
  })
}

export function saveApprovalSetting(data) {
  return request({
    url: `${url}/save`,
    method: 'post',
    data
  })
}
